module.exports = ".search-input input{\r\n    color:#000 !important;\r\n}\r\na{\r\n    color:#000 !important;\r\n}"